import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Box, Flex, Select, Text } from '@chakra-ui/react'
import { useState, useEffect } from "react"

function Pagination({ table, totalProducts, productsPerPage,  }) {

    let prodSelect = [productsPerPage]


  useEffect(() => {
    table.setPageSize(productsPerPage)
  }, [])

    let i = productsPerPage
    do {
        i = i + productsPerPage
        prodSelect.push(i)

    } while (i < totalProducts)

    const lastPage = Math.ceil(totalProducts / table.getState().pagination.pageSize)

    return (
        <>
            <Flex p={'0rem 5rem'}>
                <Box userSelect={'none'} mt={'20px'} width={'100%'} textAlign={'left'} display={'flex'} alignItems={'center'}>
                    {
                        table.getState().pagination.pageIndex + 1 === 1 &&
                        <>
                            <Select w={{ base: '6rem', sm: '5rem' }} placeholder='' value={table.getState().pagination.pageSize} onChange={(event) => { table.setPageSize(Number(event.target.value)) }}>
                                {
                                    prodSelect.map((prodSel, index) => {
                                        return <option key={index} value={prodSel}>{prodSel}</option>
                                    })
                                }
                            </Select>
                            <Text fontSize={'md'} ml={'10px'}>rodyti per puslapi</Text>
                        </>
                    }
                </Box>

                <Box userSelect={'none'} mt={'20px'} width={'100%'} textAlign={'right'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                    {
                        table.getPageCount() > 1 &&

                        <>
                            <ChevronLeftIcon cursor={'pointer'} _hover={{ color: 'green' }} fontSize={'30px'} visibility={table.getState().pagination.pageIndex + 1 !== 1 ? 'visible' : 'hidden'} onClick={(e) => {
                                const page = table.getState().pagination.pageIndex
    
                                    table.setPageIndex(page -1)
                                }} />
                            {table.getState().pagination.pageIndex + 1}
                            <ChevronRightIcon cursor={'pointer'} _hover={{ color: 'green' }} fontSize={'30px'} visibility={table.getState().pagination.pageIndex + 1 !== lastPage ? 'visible' : 'hidden'}
                                onClick={(e) => {
                                    const page = table.getState().pagination.pageIndex
            
                                    table.setPageIndex(page + 1)
              
                                }} />

                        </>
                    }
                </Box>
            </Flex>
        </>
    )
}

export default Pagination